import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import { PermissionID } from 'ctp-user-auth-service';
import CompatibilityChecker from '@/views/CompatibilityChecker/CompatibilityChecker.vue';
import DevicesList from '@/views/Devices/DevicesList/DevicesList.vue';
import History from '@/views/Devices/DevicesHistory/History.vue';
import Domains from '@/views/TollDomains/Domains/Domains.vue';
import Overview from '@/views/TollDomains/Domains/components/Overview/Overview.vue';
import OverviewNewPeriodStepper from '@/views/TollDomains/Domains/components/Overview/OverviewNewPeriodStepper.vue';
import RuleDetails from '@/views/TollDomains/Domains/components/RuleDetails/RuleDetails.vue';
import Dat from '@/views/TollDomains/Dat/Dat.vue';
import Instances from '@/views/TollDomains/Instances/Instances.vue';
import UserManagement from '@/views/UserManagement/UserManagement.vue';
import PermissionsError from '@/views/PermissionsError/PermissionsError.vue';
import { state as PermissionState } from '@/store/modules/permissions';
import { IRole } from '@/store/modules/permissions/types';
import VUserRole from '@/views/UserRole/VUserRole.vue';
import Personalisation from '@/views/Personalisation/Personalisation.vue';
import userManager from '@/auth';
import store from '@/store';
import Dashboard from '@/views/Dashboard/Dashboard.vue';
import { state as userState } from '@/store/modules/user';

Vue.use(VueRouter);

const redirectURLKey = 'after_login_redirect';

const routes: RouteConfig[] = [
  {
    path: '*',
    redirect: {
      name: 'devices-list'
    },
    name: 'redirect-default'
  },
  {
    path: '/',
    redirect: {
      name: 'devices-list'
    },
    name: 'default'
  },
  {
    path: '/callback',
    name: 'auth-callback',
    beforeEnter: async (to, from, next) => {
      // Handle oidc callback
      if (to.query && to.query.code) {
        await userManager.signinRedirectCallback(to.fullPath);
      }
      return next({
        path: sessionStorage[redirectURLKey] || '/'
      });
    }
  },
  {
    path: '/checker',
    name: 'compatibility-checker',
    meta: {
      text: 'deviceList',
      icon: 'mdi-devices',
      id: 22
    },
    component: CompatibilityChecker
  },
  {
    path: '/devices',
    name: 'devices',
    meta: {
      text: 'deviceList',
      hideChildren: false
    },
    redirect: {
      name: 'devices-list'
    }
  },
  {
    path: '/devices/devices-list',
    name: 'devices-list',
    meta: {
      text: 'deviceList',
      icon: 'mdi-devices',
      id: 0
    },
    component: DevicesList
  },
  {
    path: '/devices/history',
    name: 'history',
    meta: {
      text: 'deviceList',
      id: 13
    },
    component: History
  },
  {
    path: '/devices/personalisation',
    name: 'personalisation',
    beforeEnter: (async (to, from, next) => {
      if (!userState.selectedMasterAccount.name) {
        await store.dispatch('user/listMasterAccounts');
      }
      next();
    }),
    meta: {
      text: 'personalisation',
      icon: 'mdi-truck-outline',
      id: 14
    },
    component: Personalisation
  },
  {
    path: '/devices/dashboard',
    name: 'dashboard',
    meta: {
      text: 'deviceList',
      icon: 'mdi-view-dashboard',
      id: 0
    },
    component: Dashboard
  },
  {
    path: '/tolling/tracking-records',
    name: 'tracking-records',
    meta: {
      text: 'vehicleTrackingRecords',
      icon: 'mdi-car',
      id: 10
    }
  },
  {
    path: '/tolling/overview',
    name: 'tolldomains-overview',
    meta: {
      text: 'geometryManagement',
      icon: 'mdi-car',
      id: 11
    },
    component: Overview
  },
  {
    path: '/tolling/overview/add',
    name: 'tolldomains-overview-new-period-stepper',
    meta: {
      text: 'geometryManagement',
      icon: 'mdi-car',
      id: 11
    },
    component: OverviewNewPeriodStepper
  },
  {
    path: '/tolling/rules',
    name: 'tolldomains-rules',
    meta: {
      text: 'rules',
      icon: 'mdi-car',
      id: 11
    },
    component: Domains
  },
  {
    path: '/tolling/rules/create',
    name: 'tolldomains-rules-create',
    beforeEnter: async (to, from, next) => {
      if (to.query && to.query.id) {
        next();
      } else {
        next('');
      }
    },
    meta: {
      text: 'rules',
      id: 13
    },
    component: RuleDetails
  },
  {
    path: '/tolling/rules/update',
    name: 'tolldomains-rules-update',
    beforeEnter: async (to, from, next) => {
      if (to.query && to.query.id && to.query.ruleId) {
        next();
      } else {
        next('');
      }
    },
    meta: {
      text: 'rules',
      id: 14
    },
    component: RuleDetails
  },
  {
    path: '/tolling/dat',
    name: 'tolldomains-dat',
    meta: {
      text: 'dat',
      id: 12
    },
    component: Dat
  },
  {
    path: '/tolling/instance',
    name: 'tolldomains-instance',
    meta: {
      text: 'dsrcInstance',
      id: 15
    },
    component: Instances
  },
  {
    path: '/access-management/user-list',
    name: 'user-list',
    meta: {
      text: 'userList',
      id: 20
    },
    component: UserManagement
  },
  {
    path: '/access-management/user-role',
    name: 'user-role',
    meta: {
      text: 'userRole',
      id: 21
    },
    component: VUserRole
  },
  {
    path: '/permissions-errors',
    name: 'permissions-errors',
    meta: {
      id: -403
    },
    component: PermissionsError
  }
  // { // maybe usefull to use this later
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About/About.vue'),
  // },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export const userHasReadPermissions = (
  currentUserRole: IRole | undefined | void,
  featureName: string
): boolean => {
  const permissions = currentUserRole && currentUserRole.permissions
    ? currentUserRole.permissions : [];
  let isAbleToRead = false;
  permissions.forEach((permission: PermissionID) => {
    if (
      permission.toString().includes(featureName)
      && (permission.toString().includes('read') || permission.toString().includes('write'))
    ) {
      isAbleToRead = true;
    }
  });
  return isAbleToRead;
};

// Before every route, ensure that user is logged in
router.beforeResolve(async (to, from, next) => {
  // Try to retrieve logged-in user from local storage
  const user = userManager.getUserSync();
  if (user && !user.expired) {
    let result = true;
    let defaultDestination = '/permissions-errors';
    const st = await store
      .dispatch('user/setCurrentUserData', user.profile)
      .then(() => PermissionState.currentUserRole)
      .catch(() => {
        result = false;
      });
    if (result && to.meta) { result = userHasReadPermissions(st, to.meta.text); }
    if (to.path !== '/permissions-errors' && !result && to.path !== '/callback') {
      if (PermissionState.currentUserRole && PermissionState.currentUserRole.permissions
        && PermissionState.currentUserRole.permissions.length) {
        const concernedRoutes = routes.filter(route => route.meta && route.meta.id >= 0)
          .sort((routeA, routeB) => (routeB.meta && routeA.meta
            && routeB.meta.id > routeA.meta.id ? -1 : 1));
        const permissions = PermissionState.currentUserRole.permissions
          .map((permission) => {
            const pLength = permission.toString().includes('read') ? 5 : 6;
            const pId = permission.toString().substr(0, permission.toString().length - pLength);
            return pId;
          });
        concernedRoutes.forEach((element) => {
          if (element.meta && permissions.includes(element.meta.text) && defaultDestination === '/permissions-errors') {
            defaultDestination = element.path;
          }
        });
      }
      return next(defaultDestination);
    }

    return next();
  }

  // Not found or expired: redirect to auth page
  sessionStorage.setItem(redirectURLKey, to.path); // Save target page for later
  await userManager.signinRedirect();
  return next(false);
});

export const getCurrentPath = (): string => router.currentRoute.path;

export const getCurrentTopic = (): string => {
  const topic = getCurrentPath().split('/');
  return topic[1] || 'devices';
};

export default router;
